export const runawayProject = {
  id: "runaway-project",
  disciplines: "Editorial, Poster, Motion",
  year: 2023,
  project: "The Runayway Project",
  initiatedAt: "FH Salzburg, Austria (Master)",
  shortInitiatedAt: "FHS, AT (MA)",
  thumbnailUrl: "/assets/Runaway_Project/00-RP-1x1-1440.webp",
  description:
    '"The Runaway Project" explores a fictional future shaped by a wearable technology that makes individual climate impact visible. Presented as an editorial retrospective set ten years later, the project documents the shift from environmental collapse toward a more sustainable reality.',
  credits: [
    "Initiated at MA Communication Design, FH Salzburg, Austria",
    "Mentoring Julia Otterbach, Gosia Warrinck",
  ],
  galleryItems: [
    {
      medias: [
        {
          type: "image",
          url: "/assets/Runaway_Project/01-RP-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Runaway_Project/02-RP-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Runaway_Project/03-RP-16x9-2560.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-twelve-lg landscape-media-sixteen-by-nine",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Runaway_Project/04-RP-1x1-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg square-media-one-by-one",
        },
        {
          type: "image",
          url: "/assets/Runaway_Project/05-RP-1x1-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg square-media-one-by-one",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Runaway_Project/06-RP-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Runaway_Project/07-RP-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: 'The title "Runaway Project" refers to a speculative attempt to outrun climate collapse through technology.',
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "video",
          sound: true,
          url: "/assets/Runaway_Project/08-RP-9x10-Video.mp4",
          poster: "/assets/Runaway_Project/08-RP-9x10-Video_thumbnail.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Runaway_Project/09-RP-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Runaway_Project/10-RP-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Runaway_Project/11-RP-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Runaway_Project/12-RP-16x9-2560.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-twelve-lg landscape-media-sixteen-by-nine",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "video",
          sound: true,
          url: "/assets/Runaway_Project/13-RP-9x10-Video.mp4",
          poster: "/assets/Runaway_Project/13-RP-9x10-Video_thumbnail.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Runaway_Project/14-RP-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "Campaign visuals introducing the fictional wearable technology RA30XN.",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Runaway_Project/15-RP-1x1-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg square-media-one-by-one",
        },
        {
          type: "image",
          url: "/assets/Runaway_Project/16-RP-1x1-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg square-media-one-by-one",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
  ],
};
